jQuery($ => {
    class MultipleSelect {
      constructor(element) {
        this._          = element;
        this._element   = $(element);
        this._selectAll = this._element.find('.m-multiple-select__checkbox--all');
        this._option    = this._element.find('.m-multiple-select__checkbox--option');
        this._checkbox  = this._element.find('.m-multiple-select__checkbox');
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._selectAll.find('.a-checkbox__input').on('change', (e) => this.handleSelectAll(e));
        this._option.find('.a-checkbox__input').on('change', (e) => this.handleOptionChange(e));
        this._checkbox.find('.a-checkbox__input').on('keydown', (e) => this.handleKeydown(e));
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Select All
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      handleSelectAll = (e) => {
        const checked = e.target.checked;
        this._option.find('.a-checkbox__input').prop('checked', checked);

        if (checked) {
          this._option.addClass('a-checkbox--checked');
        } else {
          this._option.removeClass('a-checkbox--checked');
        }
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Option
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      handleOptionChange = (e) => {
        if (!e.target.checked) {
          this._selectAll.find('.a-checkbox__input').prop('checked', false);
          this._selectAll.removeClass('a-checkbox--checked');
        } else {
          const checkCount = this._element.find('.m-multiple-select__checkbox--option.a-checkbox--checked').length + 1;
          const allChecked = checkCount === this._option.length;
          
          if (allChecked) {
            this._selectAll.find('.a-checkbox__input').prop('checked', true);
            this._selectAll.addClass('a-checkbox--checked');
          }
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleKeydown = event => {
        switch (event.key) {
          case "ArrowUp":
            event.preventDefault();
            const $prevCheckbox = $(event.target).closest('.m-multiple-select__checkbox').prev();

            if ($prevCheckbox[0]) {
              $prevCheckbox.find(".a-checkbox__input").focus();
            }
            break;

          case "ArrowDown":
            event.preventDefault();
            const $nextCheckbox = $(event.target).closest('.m-multiple-select__checkbox').next();

            if ($nextCheckbox[0]) {
              $nextCheckbox.find(".a-checkbox__input").focus();
            }
            break;

          case "Home":
            event.preventDefault();
            this._checkbox
              .parent()
              .find(".m-multiple-select__checkbox")
              .first()
              .find(".a-checkbox__input")
              .focus();
            break;

          case "End":
            event.preventDefault();
            this._checkbox
              .parent()
              .find(".m-multiple-select__checkbox")
              .last()
              .find(".a-checkbox__input")
              .focus();
            break;
        }
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.multiple_select = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].multiple_select = new MultipleSelect(_[i], opt);
        else
          ret = _[i].multiple_select[opt].apply(_[i].multiple_select, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-multiple-select').multiple_select();
});